import { createReducer, on } from "@ngrx/store";
import { ProvinceDto } from "src/app/api/models";
import * as ProvinceActions from "./province.actions";
import { resetProvince } from './province.actions';

export const provinceFeatureKey = "province";

export interface ProvinceState {
	provinceList: ProvinceDto[] | undefined;
}

export const initialState: ProvinceState = {
	provinceList: undefined,
};

export const provinceReducer = createReducer(
	initialState,
	on(ProvinceActions.loadProvincesSuccess, (state, { data }) => ({ ...state, provinceList: data })),
	on(ProvinceActions.loadProvincesFailure, (state, action) => ({ ...state, loadingProvincesError: action.error })),
	on(resetProvince, () => initialState)

);
